import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Nuovo prodotto',
  fields: {
    type: {
      label: 'Tipo di prodotto',
      options: {
        [SubscriptionProductType.Plan]: 'Piano',
        [SubscriptionProductType.AddOn]: 'Componente aggiuntivo',
        [SubscriptionProductType.GoogleAdsPlan]: 'Piano Google Ads',
      },
    },
    name: {
      label: 'Nome interno',
      placeholder: 'Inserisci il nome interno del prodotto',
    },
    public_name: {
      label: 'Nome pubblico',
      placeholder: 'Inserisci il nome pubblico del prodotto',
    },
    description: {
      label: 'Descrizione',
    },
  },
  buttons: {
    save: 'Salva',
    cancel: 'Annulla',
  },
  feedback: {
    missing_info: 'Informazioni mancanti',
  },
  toasts: {
    plan_got_created: 'Prodotto creato',
    plan_got_updated: 'Prodotto aggiornato',
  },
};
